import { Megaphone } from "lucide-react";
import { useContent } from "@/content";
import { Reveal } from "@/components/Motion";
import { V3Section, V3Eyebrow, V3Title } from "@/sections/v3/shared";

// 8. Jury — intro/outro en deux colonnes, profils en liste numérotée sur 3 colonnes.
export const Jury3 = () => {
  const j = useContent().jury;
  return (
    <V3Section id={j.id} bg="#1A1213" className="py-24 md:py-32">
      <V3Eyebrow>{j.eyebrow}</V3Eyebrow>
      <V3Title testid="jury-title">{j.title}</V3Title>

      <div className="mt-10 grid gap-6 md:grid-cols-2 md:gap-12">
        {j.intro.map((p, i) => (
          <Reveal key={i} delay={i * 0.08}>
            <p className={`leading-relaxed text-white/80 ${i === 0 ? "font-serif text-[1.3rem] italic text-white md:text-[1.45rem]" : "text-[0.95rem]"}`}>{p}</p>
          </Reveal>
        ))}
      </div>

      <Reveal delay={0.1}>
        <p className="mt-16 text-[0.75rem] uppercase tracking-[0.3em] text-copper">{j.profilesTitle}</p>
      </Reveal>
      <ol className="mt-6 grid gap-x-12 sm:grid-cols-2 lg:grid-cols-3" data-testid="jury-profiles">
        {j.profiles.map((p, i) => (
          <Reveal as="li" key={p} delay={(i % 3) * 0.06} className="flex items-baseline gap-4 border-t border-copper/25 py-4">
            <span className="w-7 shrink-0 font-sans text-[0.75rem] tabular-nums tracking-[0.18em] text-copper">{String(i + 1).padStart(2, "0")}</span>
            <span className="font-serif text-[1.1rem] leading-snug text-white/90">{p}</span>
          </Reveal>
        ))}
      </ol>

      <Reveal delay={0.1}>
        <p className="mt-12 flex w-fit items-center gap-4 border border-copper/40 px-6 py-4 text-[0.78rem] uppercase tracking-[0.25em] text-blush" data-testid="jury-banner">
          <Megaphone size={18} strokeWidth={1.2} className="shrink-0 text-copper" aria-hidden="true" />
          {j.banner}
        </p>
      </Reveal>

      <div className="mt-14 grid gap-6 md:grid-cols-2 md:gap-12">
        <Reveal>
          <p className="text-[0.95rem] leading-relaxed text-white/80">{j.outro}</p>
        </Reveal>
        <Reveal delay={0.08}>
          <p className="text-[0.95rem] leading-relaxed text-white/70">{j.nb}</p>
        </Reveal>
      </div>
    </V3Section>
  );
};
